export default __webpack_public_path__ + "static/media/skrill_logo.f080e458.png";